// extracted by mini-css-extract-plugin
export var container = "_5o-0";
export var icon = "_5o-1";
export var text = "_5o-2";